/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I repeat multiple lines?`)
};

const es_tr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo repetir múltiples líneas?`)
};

const de_tr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich mehrere Zeilen wiederholen?`)
};

const nl_tr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik meerdere regels herhalen?`)
};

const fr_tr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je répéter plusieurs lignes?`)
};

const it_tr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso ripetere più righe?`)
};

const pt_br2_tr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso repetir várias linhas?`)
};

const pt_tr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso repetir múltiplas linhas?`)
};

const ja_tr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数行を繰り返すことはできますか？`)
};

const zh_tr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以重复多行吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_faq2_q", locale)
	if (locale === "en") return en_tr_faq2_q(inputs)
	if (locale === "es") return es_tr_faq2_q(inputs)
	if (locale === "de") return de_tr_faq2_q(inputs)
	if (locale === "nl") return nl_tr_faq2_q(inputs)
	if (locale === "fr") return fr_tr_faq2_q(inputs)
	if (locale === "it") return it_tr_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_tr_faq2_q(inputs)
	if (locale === "pt") return pt_tr_faq2_q(inputs)
	if (locale === "ja") return ja_tr_faq2_q(inputs)
	return zh_tr_faq2_q(inputs)
};